<template lang="html">
    <v-app class="login">
        <v-container fluid fill-height class="login-page">
            <v-layout align-center justify-center>
                <v-flex xs12 sm8 md6 lg4 xl3>
                    <v-card class="login-card">
                        <br />
                        <!-- <v-img class="rolo-logo" :src="require('@/assets/logo.png')" height="150px"/> -->
                        <v-img class="rolo-logo" alt="DigiPoS_KDS" :src="require('@/assets/digitory/Light_Transparent.png')" height="100px" width="300px"  />
                        <br />
                        <!-- <h2 class="text-xs-center">ROLO KDS</h2> -->
                        <h2 class="text-xs-center">DigiPoS KDS</h2>
                        <v-form>
                            <v-flex pt-2 pb-1 offset-xs1 xs10>
                                <v-text-field label="Email ID" name="emailId" autofocus :rules="formValidation.emailRules"
                                    required prepend-icon="email" v-model="user.emailId">
                                </v-text-field>
                            </v-flex>
                            <v-flex pt-1 pb-1 offset-xs1 xs10>
                                <v-text-field label="Password" type="password" name="password" :rules="formValidation.passwordRules"
                                    required prepend-icon="lock" v-model="user.password" @keyup.enter.native="signIn()">
                                </v-text-field>
                            </v-flex>
                        </v-form>
                        <v-card-actions>
                            <v-layout row wrap text-xs-right class="px-4 py-3">
                              <v-flex xs3>
                                <version />
                              </v-flex>
                                <v-flex xs9>
                                    <v-btn color="success" @click="signIn()" :loading="isSignIn">
                                        Login
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                            <!-- <v-spacer></v-spacer> -->
                        </v-card-actions>
                        <v-layout row wrap text-xs-center align-center class="caption px-2 pb-3">
                          <v-flex xs12 >
                           connected to <br/> {{getURL()}}
                          </v-flex>
                          <v-flex xs12>
                           <a @click="editConnection()" style="text-decoration: underline">
                            Edit Connection 
                           </a>
                          </v-flex>
                        </v-layout>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>

        <v-dialog v-model="isMultiStore" max-width="575" persistent scrollable>
            <v-card style="min-height:00px">
                <v-card-title class="headline elevation-1">
                    Select Store
                    <v-spacer></v-spacer>
                    <v-icon color="error" @click="closeMultiStoreDialog()">clear</v-icon>
                </v-card-title>
                <!-- <v-divider></v-divider> -->
                <v-card-text>
                    <v-container grid-list-lg class="pa-0 py-2">
                        <v-layout row wrap>
                            <v-flex text-xs-center v-for="store in stores" xs6 md3 :key="store.name">
                                <v-card ripple hover class="stores elevation-5" huge @click.native="selectStore(store)">
                                    {{store.name}}
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-app>
</template>

<style scoped>
.login {
  overflow: hidden;
}

.login-page {
  background-image: url("../../assets/finalbg.jpg");
  background-size: cover;
  background-repeat: no-repeat;
}

.rolo-logo {
  width: 150px;
  margin-left: auto;
  margin-right: auto;
}

.stores {
  height: 100px;
  display: flex;
  align-items: center;
  /* Uncomment next line to get horizontal align also */
  justify-content: center;
  text-align: center;
  font-size: 15px;
}
</style>


<script>
import { deviceSetup } from "@/providers/RoloProvider";
import version from "@/components/utils/version.vue";
import { globalData } from "@/providers/global";

export default {
  name: "Login",
  components: {
    version,
  },
  props: {
    hasError: Boolean,
    errorMsg: {
      type: String,
      default: "Something went wrong, please login again to continue",
    },
  },
  mixins: [globalData],
  data() {
    return {
      user: {
        emailId: "",
        password: "",
      },
      isMultiStore: false,
      formValidation: {
        emailRules: [
          (v) => !!v || "E-mail is required",
          (v) =>
            /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
            "E-mail must be valid",
        ],
        passwordRules: [(v) => !!v || "Enter password"],
      },
      isSignIn: false,
      userNotValid: false,
      authenticationErrorMessage: "",
      stores: [],
      version: "",
      env: "",
    };
  },
  methods: {
    getURL() {
      return this.$apiURL;
    },
    editConnection() {
      this.$router.push({
        name: "domainSetup",
      });
    },
    signIn() {
      const data = {
        emailID: this.user.emailId,
        password: this.user.password,
        device_id: globalData.$data.$deviceId,
        device_name: globalData.$data.$deviceName,
        os: globalData.$data.$os,
        appType: "kds",
        appVersion: globalData.$data.$appVersion,
      };
      this.isSignIn = true;

      this.$http
        .post(this.$apiURL + "login", data)
        .then(function (resp) {
          // console.log(resp);
          this.isSignIn = false;
          localStorage.setItem("token", resp.body.token);

          if (resp.status === 207) {
            localStorage.setItem("accountId", resp.body.account_id);
            this.stores = resp.body.stores;
            this.isMultiStore = true;
            return;
          }
          // console.log("acc", resp.body);
          deviceSetup(resp.body);
          this.$router.push({
            path: `/store/${resp.body.store.id}/lines`,
          });
        })
        .catch(function (failure) {
          // console.log(failure);
          this.$store.commit("showSnackbar", {
            color: "error",
            message: failure.body.message || "Something went wrong, try again",
          });
          this.isSignIn = false;
          this.userNotValid = true;
          if (failure.status === 400) {
            this.authenticationErrorMessage = failure.body.message;
            return;
          }

          // this.$router.push("/domainSetup");
        });
    },
    closeMultiStoreDialog() {
      this.isMultiStore = false;
    },
    selectStore(store) {
      this.$root.$loader.start(
        "Setting up your " + store.name + " Store, please wait",
        {}
      );
      // console.log(store);
      const data = {
        device_id: globalData.$data.$deviceId,
        device_name: globalData.$data.$deviceName,
        account_id: localStorage.getItem("accountId"),
        token: localStorage.getItem("token"),
        os: globalData.$data.$os,
        appType: "kds",
        appVersion: globalData.$data.$appVersion,
        ...store,
      };
      this.$http
        .put(this.$apiURL + "store/" + store.id + "/setup", data)
        .then(function (resp) {
          // localStorage.setItem("token", resp.body.token);
          if (resp.status === 200) {
            deviceSetup(resp.body);
            this.$root.$loader.stop();
            this.$router.push({
              path: `/store/${store.id}/lines`,
            });
            return;
          }
        })
        .catch((failure) => {
          console.log(failure);
          this.$root.$loader.stop();
          this.$store.commit("showSnackbar", {
            color: "error",
            message: failure.body.message,
          });
        });
    },
  },
  created() {
    if (this.hasError) {
      this.$store.commit("showSnackbar", {
        timeout: 3000,
        message: this.errorMsg,
        color: "error",
      });
    }
  },
};
</script>